import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
const Ctx = createContext(null);
export function ThemeProvider({ children }) {
    const [mode, setModeState] = useState(() => (typeof localStorage !== "undefined"
        ? localStorage.getItem("il:theme")
        : "light") || "light");
    const [accent, setAccentState] = useState(() => (typeof localStorage !== "undefined"
        ? localStorage.getItem("il:accent")
        : "blue") || "blue");
    useEffect(() => {
        if (typeof document !== "undefined") {
            const root = document.documentElement;
            root.setAttribute("data-theme", mode);
            root.setAttribute("data-accent", accent);
        }
    }, [mode, accent]);
    const setMode = useCallback((m) => {
        setModeState(m);
        if (typeof localStorage !== "undefined")
            localStorage.setItem("il:theme", m);
    }, []);
    const setAccent = useCallback((a) => {
        setAccentState(a);
        if (typeof localStorage !== "undefined")
            localStorage.setItem("il:accent", a);
    }, []);
    const value = useMemo(() => ({ mode, accent, setMode, setAccent }), [mode, accent, setMode, setAccent]);
    return _jsx(Ctx.Provider, { value: value, children: children });
}
export function useTheme() {
    const ctx = useContext(Ctx);
    if (!ctx)
        throw new Error("useTheme must be used within ThemeProvider");
    return ctx;
}
